import { useEffect, useState } from "react";
import api from "@/lib/api";

const KEY = "smmm_staff_names";

// Daha önce toplu atamada yazılan personel isimleri bu tarayıcıda hatırlanır (öneri listesi için)
export function rememberStaff(name) {
  try {
    const a = JSON.parse(localStorage.getItem(KEY) || "[]");
    if (name && !a.includes(name)) { a.push(name); localStorage.setItem(KEY, JSON.stringify(a)); }
  } catch { /* yoksay */ }
}

// Personel adı önerileri: kayıtlı kullanıcılar + daha önce atamada kullanılan isimler
export function useStaffNames() {
  const [names, setNames] = useState([]);
  useEffect(() => {
    let mem = [];
    try { mem = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { mem = []; }
    api.get("/users")
      .then((r) => setNames([...new Set([...(r.data || []).map((u) => u.name).filter(Boolean), ...mem])]))
      .catch(() => setNames(mem));
  }, []);
  return names;
}
